import Wrapper from "../assets/wrappers/BigSidebar"
import Logo from './Logo'
import NavLinks from './NavLinks'

const BigSidebar = () => {
    
    return (
        <Wrapper>
            <div className='sidebar-container show-sidebar'>
                <div className="content">
                    <header>
                        <Logo />
                    </header>
                    <NavLinks/>
                </div>
            </div>
        </Wrapper>
    )
}

export default BigSidebar